import { useTranslation } from '@frontend/i18n';
import { useDiscoverReaderQuery } from '@frontend/payments-collection-flow';
import { useSelectedLocation, useMerchants } from '@frontend/payments-hooks';
import { Table, Text } from '@frontend/design-system';
import { generateColumns } from './generate-columns';
import { useTerminalSettings } from './use-terminal-settings';

export const TerminalSettings = () => {
  const { t } = useTranslation('payments');
  const locationId = useSelectedLocation();
  const { stripeLocationId } = useMerchants(locationId)['firstLocation'];
  const { hasTerminalsEnabled } = useTerminalSettings(locationId);
  const query = useDiscoverReaderQuery({ stripeLocationId, locationId });

  if (!hasTerminalsEnabled) return <Text>{t('Terminal Payments are not enabled for this location.')}</Text>;
  return (
    <>
      <Table
        data={query.data ?? ([] as NonNullable<typeof query.data>)}
        isLoading={query.isLoading}
        colConfig={generateColumns()}
        isPaginated
        clientPaginationConfig={{
          defaultRowsPerPage: 5,
          rowsPerPageOptions: [5, 10, 15],
        }}
      />
    </>
  );
};
